module.exports = __webpack_public_path__ + "static/img/7.156725d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/7.png
// module id = tJ+q
// module chunks = 0